import Region from './Region';
import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('regions/' + id).then(function (value) { return new Region(value); });
        return api.get('regions');
    };
    default_1.prototype.create = function (data) {
        return api.post('regions', data);
    };
    default_1.prototype.update = function (id, data) {
        return api.put('regions/' + id, data);
    };
    default_1.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    default_1.prototype.disable = function (id, disabled) {
        throw new Error('Method not implemented.');
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Regions/RegionsStore.ts
// module id = 747
// module chunks = 0